<app-header />
<div class="body">
    <app-sidebar />
    <div class="content">
        <main>
            <router-outlet />
        </main>
        <app-footer />
    </div>
</div>
<router-outlet name="modal" />
<router-outlet name="dialog" />
<router-outlet name="subdialog" />
